var WebAudioChannel = /** @class */ (function () {
    function WebAudioChannel(groupID, groupVolume, groupPan) {
        var _this = this;
        if (groupID === void 0) { groupID = 0; }
        if (groupVolume === void 0) { groupVolume = 1; }
        if (groupPan === void 0) { groupPan = 1; }
        this._isPlaying = false;
        this._isLooping = false;
        this._isDecoding = false;
        this._volume = 1;
        this._pan = 0;
        this._groupID = 0;
        this._groupVolume = 1;
        this._groupPan = 0;
        this._startTime = 0;
        this._groupID = groupID;
        this._groupVolume = groupVolume;
        this._groupPan = groupPan;
        this._audioCtx = WebAudioChannel.getAudioContext();
        this._usingNativePanner = typeof this._audioCtx.createStereoPanner === 'function';
        this._gainNode = this._audioCtx.createGain();
        this._gainNode.gain.value = this._groupVolume * this._volume;
        this._pannerNode = this._usingNativePanner ?
            this._audioCtx.createStereoPanner() :
            this._audioCtx.createPanner();
        if (this._usingNativePanner)
            this._pannerNode.pan.value = this._pan;
        else
            this._pannerNode.setPosition(Math.sin(this._pan * (Math.PI / 2)), 0, Math.cos(this._pan * (Math.PI / 2)));
        this._gainNode.connect(this._pannerNode);
        this._pannerNode.connect(this._audioCtx.destination);
        this._onEndedDelegate = function (event) { return _this._onEnded(event); };
    }
    WebAudioChannel.getAudioContext = function () {
        if (!WebAudioChannel._audioCtx && (window['AudioContext'] || window['webkitAudioContext']))
            WebAudioChannel._audioCtx = new (window['AudioContext'] || window['webkitAudioContext'])();
        if (WebAudioChannel._audioCtx && WebAudioChannel._audioCtx.state == 'suspended')
            WebAudioChannel._audioCtx.resume();
        return WebAudioChannel._audioCtx;
    };
    WebAudioChannel.stopAllSounds = function (channelGroup) {
        if (channelGroup === void 0) { channelGroup = -1; }
        var len = WebAudioChannel._channels.length;
        if (channelGroup < 0) {
            for (var j = 0; j < len; j++) {
                WebAudioChannel._channels[j].stop();
            }
            WebAudioChannel._channels.length = 0;
            return;
        }
        var aliveChannels = [];
        for (var j = 0; j < len; j++) {
            if (WebAudioChannel._channels[j].groupID == channelGroup) {
                WebAudioChannel._channels[j].stop();
            }
            else {
                aliveChannels[aliveChannels.length] = WebAudioChannel._channels[j];
            }
        }
        WebAudioChannel._channels = aliveChannels;
    };
    WebAudioChannel.setChannelGroupVolume = function (value, channelGroup) {
        if (channelGroup === void 0) { channelGroup = -1; }
        var len = WebAudioChannel._channels.length;
        if (channelGroup < 0) {
            for (var j = 0; j < len; j++) {
                WebAudioChannel._channels[j].groupVolume = value;
            }
            return;
        }
        for (var j = 0; j < len; j++) {
            if (WebAudioChannel._channels[j].groupID == channelGroup) {
                WebAudioChannel._channels[j].groupVolume = value;
            }
        }
    };
    Object.defineProperty(WebAudioChannel.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "currentTime", {
        get: function () {
            if (this._isDecoding) {
                return this._currentTime;
            }
            return this._audioCtx.currentTime - this._startTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "groupID", {
        get: function () {
            return this._groupID;
        },
        set: function (value) {
            this._groupID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "groupVolume", {
        get: function () {
            return this._groupVolume;
        },
        set: function (value) {
            if (this._groupVolume == value)
                return;
            this._groupVolume = value;
            this._gainNode.gain.value = this._groupVolume * this._volume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "groupPan", {
        get: function () {
            return this._groupPan;
        },
        set: function (value) {
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "volume", {
        get: function () {
            return this._volume;
        },
        set: function (value) {
            if (this._volume == value)
                return;
            this._volume = value;
            this._gainNode.gain.value = this._groupVolume * this._volume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WebAudioChannel.prototype, "pan", {
        get: function () {
            return this._pan;
        },
        set: function (value) {
            if (this._pan == value)
                return;
            this._pan = value;
            if (this._usingNativePanner)
                this._pannerNode.pan.value = this._pan;
            else
                this._pannerNode.setPosition(Math.sin(this._pan * (Math.PI / 2)), 0, Math.cos(this._pan * (Math.PI / 2)));
        },
        enumerable: true,
        configurable: true
    });
    WebAudioChannel.prototype.isPlaying = function () {
        return this._isPlaying;
    };
    WebAudioChannel.prototype.isLooping = function () {
        return this._isLooping;
    };
    WebAudioChannel.prototype.isDecoding = function () {
        return this._isDecoding;
    };
    WebAudioChannel.prototype.play = function (buffer, offset, loop, id) {
        var _this = this;
        if (offset === void 0) { offset = 0; }
        if (loop === void 0) { loop = false; }
        if (id === void 0) { id = 0; }
        this._isPlaying = true;
        this._isLooping = loop;
        this._currentTime = offset;
        //console.log("play with offset time", offset)
        this._id = id;
        this._isDecoding = true;
        buffer = buffer.slice(0);
        //fast path for short sounds
        if (WebAudioChannel._decodeCache[id])
            this._onDecodeComplete(WebAudioChannel._decodeCache[id]);
        else if (!WebAudioChannel._errorCache[id])
            this._audioCtx.decodeAudioData(buffer, function (buffer) { return _this._onDecodeComplete(buffer); }, function (event) { return _this._onError(event); });
        else
            this.stop();
    };
    WebAudioChannel.prototype.stop = function () {
        // for AVM1 it is a bug to stop a audio thats currently decoding.
        // when we call stopAllASounds() during audio-decode, this audio should still play
        //if(this._isDecoding){
        //	return;
        //}
        if (!this._isPlaying)
            return;
        this._isPlaying = false;
        this._isLooping = false;
        this._isDecoding = false;
        if (this._source)
            this._disposeSource();
    };
    WebAudioChannel.prototype._onDecodeComplete = function (buffer) {
        if (!this._isPlaying)
            return;
        this._isDecoding = false;
        //if (buffer.duration < 2) //cache all buffers?
        WebAudioChannel._decodeCache[this._id] = buffer;
        if (this._source)
            this._disposeSource();
        this._source = this._audioCtx.createBufferSource();
        this._source.loop = this._isLooping;
        this._source.connect(this._gainNode);
        this._source.buffer = buffer;
        this._duration = buffer.duration;
        this._pan = 0;
        this._startTime = this._audioCtx.currentTime - this._currentTime;
        this._source.onended = this._onEndedDelegate;
        try {
            this._gainNode.gain.value = this._groupVolume * this._volume;
            if (this._usingNativePanner)
                this._pannerNode.pan.value = this._pan;
            else
                this._pannerNode.setPosition(Math.sin(this._pan * (Math.PI / 2)), 0, Math.cos(this._pan * (Math.PI / 2)));
            // TODO: offset / startTime make problem in dino-run game:
            this._source.start(this._audioCtx.currentTime, this._currentTime);
        }
        catch (error) {
            console.log('Error starting audio: ' + error);
            this._disposeSource();
        }
    };
    WebAudioChannel.prototype._onError = function (event) {
        console.log('Error with decoding audio data');
        WebAudioChannel._errorCache[this._id] = true;
        this.stop();
    };
    WebAudioChannel.prototype._onEnded = function (event) {
        if (this.onSoundComplete) {
            this.onSoundComplete();
        }
        this.stop();
    };
    WebAudioChannel.prototype._disposeSource = function () {
        //clean up
        this._source.onended = null;
        this._source.stop(this._audioCtx.currentTime);
        this._source.disconnect();
        // delete this._source.buffer;
        // delete this._source;
        this._source = null;
    };
    WebAudioChannel.maxChannels = 64; // for icycle: 128;
    WebAudioChannel._channels = new Array();
    WebAudioChannel._decodeCache = new Object();
    WebAudioChannel._errorCache = new Object();
    return WebAudioChannel;
}());
export { WebAudioChannel };
var audioCtx = WebAudioChannel.getAudioContext();
// context state at this time is `undefined` in iOS8 Safari
if (audioCtx && audioCtx.state === 'suspended') {
    var resume_1 = function () {
        audioCtx.resume();
        //create empty buffer
        var buffer = audioCtx.createBuffer(1, 1, 22050);
        var source = audioCtx.createBufferSource();
        source.buffer = buffer;
        source.connect(audioCtx.destination);
        source.start();
        setTimeout(function () {
            if (audioCtx.state === 'running') {
                document.removeEventListener('mousedown', resume_1, false);
            }
        }, 0);
    };
    document.addEventListener('mousedown', resume_1, false);
}
